'use strict'

import constants from '@akerolabs/akero-constants/src/index.js'

/**
 * @type {Object}
 * @description This is the main configuration for the akero
 * ui components, we get the config from here in all of the
 * components, as this can be extended when installing the
 * akero components into vue
 */
let config = {
  defaultUserLevel: 'accountuser',
  ...constants,
}

/**
 * @param {Object} options
 * @description Overrides the default options with a new
 * configuration object
 */
export const setOptions = (options) => {
  config = options
}

export { config as default }
